import { render, staticRenderFns } from "./RosterLocationFooter.vue?vue&type=template&id=303d514a&scoped=true&"
import script from "./RosterLocationFooter.vue?vue&type=script&lang=js&"
export * from "./RosterLocationFooter.vue?vue&type=script&lang=js&"
import style0 from "./RosterLocationFooter.vue?vue&type=style&index=0&id=303d514a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303d514a",
  null
  
)

export default component.exports